var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaProfiloFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.99947 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2b2a28;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.73971,4.74A4.74,4.74,0,1,1,9.99972,0,4.7415,4.7415,0,0,1,14.73971,4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.98971,19.39a.48761.48761,0,0,1-.11.42.54832.54832,0,0,1-.41.19h-7.14l3.31-3.31a.53033.53033,0,0,0-.75-.75l-4.06,4.06h-1.66l-3.4-3.4-.66-.66a.53033.53033,0,0,0-.75.75l2.26,2.26,1.05,1.05h-7.14a.54843.54843,0,0,1-.41-.19.488.488,0,0,1-.11-.42l1.31-7.9a5.469,5.469,0,0,1,1.54-2.99l.42-.42a.586.586,0,0,1,.17-.1.52573.52573,0,0,1,.39,0,.452.452,0,0,1,.17.11.54921.54921,0,0,1,.07.09s.02.01.02.02a6.83944,6.83944,0,0,0,11.8,0,.0098.0098,0,0,1,.01-.01.0098.0098,0,0,0,.01-.01.54868.54868,0,0,1,.07-.09.45264.45264,0,0,1,.17-.11.52557.52557,0,0,1,.39,0,.5863.5863,0,0,1,.17.1l.42.42a5.47426,5.47426,0,0,1,1.54,2.98Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaProfiloFill);
export default __webpack_public_path__ + "static/media/iconaProfiloFill.2cb309298ba0b97c51be9f485fa38c40.svg";
export { ForwardRef as ReactComponent };